class DateProvider {
    public now(): Date {
        return new Date();
    }
}

export default new DateProvider();
